import { render, staticRenderFns } from "./GroupSettingPage.vue?vue&type=template&id=7a84ad1a"
import script from "./GroupSettingPage.vue?vue&type=script&lang=js"
export * from "./GroupSettingPage.vue?vue&type=script&lang=js"
import style0 from "./GroupSettingPage.vue?vue&type=style&index=0&id=7a84ad1a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports